import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/AreaInfo/area-info-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/FAQ/faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/Hero/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/RelatedTowns/related-towns.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/Services/services-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/Story/story-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/our-service-areas/[town]/ui/Testimonial/testimonial-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/sections/GetInTouch/get-in-touch-section.tsx");
